// @givmo/app-admin — "Sign-in & security", the person's own account page (AS-WEB11; D-AS-21's A4
// placement for the employer portal: the account menu's row opens it as a PAGE, never a sixth
// settings tab beside the company-wide "Security" tab, and it retires with the portal).
//
// The page carries the card's heading and line, so the card renders `headless` beneath them. The
// card is `@givmo/passkeys`' (the same one the charity console places under Settings › Your
// settings); its "Confirm it's you" sheet runs on this portal's host (`useAdminStepUpHost`).
//
// ⚠ NOTHING OF IT RENDERS UNTIL THE PASSKEY SURFACE IS SERVED HERE, its heading included: the page
// answers its address with nothing while `GET /users/me/passkeys` has not answered 200 (dark, or not
// yet read), the account menu shows no row leading here, and the bar does not name it. The backend's
// flag is the only switch (law 5); a page that named the surface while dark would reveal it. Nor on
// a page host no passkey can work on (EP-MNT18, `passkeysUsableHere`: off `givmo.io`, as a raw
// `*.web.app` host is): there the read is never made, so the page is just as absent.
//
// DATA CONTRACT: the root keeps `page-sign-in-security`.

import { PageHeader, testIdProp } from '@givmo/design-system';
import { SignInSecurityCard, passkeysUsableHere, servedData, useMyPasskeys } from '@givmo/passkeys';
import { StepUpHostProvider } from '@givmo/step-up';
import { useAuth } from '../../auth/auth-context';
import { useAdminStepUpHost } from '../step-up/admin-step-up-host';

export const SIGN_IN_SECURITY_ROUTE = '/sign-in-security';

export function SignInSecurityPage() {
  const { user, authenticator } = useAuth();
  const host = useAdminStepUpHost();
  const served =
    servedData(useMyPasskeys(passkeysUsableHere() ? (user?.uid ?? null) : null)) !== undefined;
  if (!served) return null;
  return (
    <div
      className="mx-auto flex w-full max-w-[960px] flex-col gap-20 px-24 py-24"
      {...testIdProp('page-sign-in-security')}
    >
      <PageHeader
        title="Sign-in & security"
        subtitle="For your Givmo account, everywhere you sign in."
      />
      <StepUpHostProvider adapter={host}>
        <SignInSecurityCard
          uid={user?.uid ?? null}
          headless
          {...(authenticator !== undefined ? { authenticator } : {})}
        />
      </StepUpHostProvider>
    </div>
  );
}
